import { useQuery } from "blitz"
import getCurrentUser from "app/users/queries/getCurrentUser"
import { useEffect } from "react"
import { Tracking } from "app/core/tracking"

export const useCurrentUser = () => {
  const [user] = useQuery(getCurrentUser, null)

  useEffect(() => {
    if (user) {
      Tracking.setUserId(user.id)
      Tracking.setEmail(user.email)
    }
  }, [user])

  return user
}
